/**
 * Moves the prepaid-discount element into price-item--regular element 
 * which comes under price__sale and removes the original
 * Functional programming approach
 */
(function() {
  'use strict';

  // Pure functions for element selection
  const querySelector = (selector, context = document) => context.querySelector(selector);
  const querySelectorAll = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const closest = (element, selector) => element?.closest(selector);

  // Functional helpers
  const pipe = (...fns) => (value) => fns.reduce((acc, fn) => fn(acc), value);
  const filter = (predicate) => (arr) => arr.filter(predicate);
  const map = (fn) => (arr) => arr.map(fn);
  const forEach = (fn) => (arr) => arr.forEach(fn);

  // Predicate functions
  const hasElement = (element) => element !== null && element !== undefined;
  const hasNoPrepaid = (element) => !querySelector('.prepaid-price, .prepaid-discount', element);
  const isValidPriceItem = (element) => hasElement(element) && hasNoPrepaid(element);
  const isNotInsidePriceItemRegular = (element) => {
    const priceItemRegular = closest(element, '.price-item--regular');
    return !priceItemRegular;
  };

  // Element finder functions
  const findPriceItemRegular = (priceSale) => querySelector('.price-item--regular', priceSale);
  const findAllPrepaidInContainer = (priceSale) => {
    const priceContainer = closest(priceSale, '.price');
    return priceContainer 
      ? querySelectorAll('.prepaid-price', priceContainer)
      : [];
  };
  const findAllPrepaidGlobal = () => querySelectorAll('.prepaid-price');
  const findPrepaidDiscount = (priceSale) => {
    const allPrepaid = [...findAllPrepaidInContainer(priceSale), ...findAllPrepaidGlobal()];
    // Filter out prepaid elements that are already inside price-item--regular
    return allPrepaid.find(prepaid => isNotInsidePriceItemRegular(prepaid)) || null;
  };

  // DOM manipulation functions
  const moveElement = (parent) => (element) => {
    if (parent && element && element.parentNode) {
      parent.appendChild(element);
      return element;
    }
    return null;
  };
  const removeElement = (element) => {
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  };

  // Main processing function
  const processPriceSale = (priceSale) => {
    const priceItemRegular = findPriceItemRegular(priceSale);
    
    if (!isValidPriceItem(priceItemRegular)) {
      return;
    }

    const prepaidDiscount = findPrepaidDiscount(priceSale);
    
    if (prepaidDiscount) {
      // Move the element (not clone) - appendChild automatically moves it
      moveElement(priceItemRegular)(prepaidDiscount);
      // The element is already moved, no need to remove separately
      // appendChild automatically removes it from its original location
    }
  };

  // Main function
  const appendPrepaidDiscount = () => {
    pipe(
      () => querySelectorAll('.price__sale'),
      forEach(processPriceSale)
    )();
  };

  // DOM ready handler
  const whenReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  };

  // Initialize
  whenReady(appendPrepaidDiscount);

  // Export for manual calls
  window.appendPrepaidDiscount = appendPrepaidDiscount;

})();
